<template>
  <fragment>
    <div class="step-app">
      <ul class="step-steps w-75" style="margin: 0 auto;">
        <li v-for="( tab, index ) in tabs" v-bind:key="index" :class="{ 'active' : tab.tabId === tabAtiva }">
          <a href="javascript:void(0)" @click="onTabClick(tab)" class="text-uppercase font-weight-normal text-center">{{tab.titulo}}</a>
        </li>
      </ul>
      <div class="step-content">
        <div class="">
          <div class="d-flex justify-content-center">
            <div class="w-75 p-3">
              <slot></slot>
            </div>
          </div>

        </div>

        


        <slot name="content-footer">
          <div class="step-footer d-flex justify-content-center" v-if="modoWizard && tabs && tabs.length > 0">
            <div class="w-75">
            <button data-direction="prev" class="d-flex btn btn-link btn-sm text-uppercase float-left" @click="onVoltar"
                    v-if="tabs[0].tabId !== tabAtiva">
              <i class="material-icons float-left">
                keyboard_arrow_left
              </i>
              <div class="pt-1">{{$t('label.voltar')}}</div>
            </button>
            <button data-direction="finish" class="btn btn-link btn-sm text-uppercase float-right" @click="onAvancar">
              <i class="material-icons">
                done
              </i>
            </button>
            </div>

          </div>
        </slot>
      </div>
      <slot name="footer"></slot>
    </div>
  </fragment>
</template>
<script>
  export default {
    model: {
      prop: 'tabAtiva',
      event: 'tab-change',
    },
    props: {
      /**
       * Define qual tab está ativa
       */
      tabAtiva: String,
      modoWizard: Boolean,
    },
    provide () {
      return {
        addTab: this.addTab,
        removeTab: this.addTab,
      }
    },
    data () {
      return {
        tabs: [],
        tabAtivaLocal: this.tabAtiva,
        numTabs: 0,
      }
    },
    watch: {
      tabAtiva (newVal) {
        this.changeTab(newVal)
      },
    },
    methods: {
      onAvancar () {
        const tabAtual = this.tabs.find(x => x.tabId === this.tabAtivaLocal)
        tabAtual.onAvancar().then(() => {
          const index = this.tabs.indexOf(tabAtual)
          if (index > 0) {
            this.changeTab(this.tabs[index - 1].tabId)
          }
        })
      },
      onVoltar () {
        const tabAtual = this.tabs.find(x => x.tabId === this.tabAtivaLocal)
        const index = this.tabs.indexOf(tabAtual)
        if (index > 0) {
          this.changeTab(this.tabs[index - 1].tabId)
        }
      },
      addTab (item) {
        const index = this.$slots.default.indexOf(item.$vnode)
        item.tabId = item.tabId ? item.tabId : `${item.titulo.replace(/ /g, '')}${index}`
        this.tabs.splice(index, 0, item)
        if (!this.tabAtivaLocal) {
          this.changeTab(item.tabId)
        }
      },
      removeTab (item) {
        const index = this.tabs.indexOf(item)
        this.tabs.splice(index, 1)
        if (this.tabs[index].tabId == this.tabId) {
          const nextTab = this.tabs[index > 0 ? index - 1 : index + 1]
          this.changeTab(nextTab.tabId)
        }
      },
      changeTab (tabId) {
        const tabAtual = this.tabs.find(x => x.tabId === this.tabAtivaLocal)
        const tabNova = this.tabs.find(x => x.tabId === tabId)

        this.tabAtivaLocal = tabId

        if (tabAtual) {
          tabAtual.ativo = false
        }
        if (tabNova) {
          tabNova.ativo = true
        }
        this.$emit('tab-change', tabId)
      },
      onTabClick (tab) {
        if (!this.modoWizard) {
          this.changeTab(tab.tabId)
        }
      },
    },
    mounted () {
      this.changeTab(this.tabAtivaLocal)
    },
  }
</script>
